import type Store from '@ember-data/store'
import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type SubscriptionTypeRoute from 'district-ui-client/subscription-type/route'
import type SessionService from 'district-ui-client/services/session'
import type School from 'district-ui-client/models/school'

export default class ManageTeachersIndexRoute extends Route {
  @service store!: Store

  @service session!: SessionService

  queryParams = {
    schoolId: {
      replace: true,
      refreshModel: false,
    },
  }

  async model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelFor<SubscriptionTypeRoute>

    const schools = await this.store.query<School>('school', {
      scope: `districts/${this.session.currentDistrict.id}`,
      // @ts-expect-error - include types not correct
      include: 'school-subscriptions',
    })
    const has3ESchool = schools.some((school) => school.oneRosterEnabledAt)
    const schoolsForSubType = schools.filter((school) => school.hasActiveSchoolSubscriptionFor(subscriptionType))

    return { schoolsForSubType, subscriptionType, has3ESchool }
  }
}
